export enum DeliveryProviderType {
  SmsGlobal = 1,
  SmsUSA = 2,
  Twilio = 3,
  Courier = 4
}
